/**
 * Label : Value row used across detail panels.
 * Pattern from spec mockup `.drow` / `.drow-label` / `.drow-val`.
 */
import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

export function InfoRow({
  label,
  value,
  mono,
  valueClassName,
}: {
  label: ReactNode;
  value: ReactNode;
  mono?: boolean;
  valueClassName?: string;
}) {
  return (
    <div className="flex items-center justify-between gap-2 text-[0.769em] py-0.5">
      <span className="text-(--color-text3) shrink-0">{label}</span>
      {/* `min-w-0` lets the value shrink below its content width; without it
          a flex item's min-width is auto and a long unbroken value (MQTT
          topic, USS base URL, GUID) overflows the panel and is clipped
          rather than wrapped. `break-words` then breaks the token itself,
          which `min-w-0` alone would not do for a string with no spaces. */}
      <span
        className={cn(
          'font-semibold text-right min-w-0 break-words',
          mono && 'font-mono',
          valueClassName,
        )}
      >
        {value}
      </span>
    </div>
  );
}
